module.exports = __webpack_public_path__ + "static/media/54.321167ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/54.png
// module id = 627
// module chunks = 0